import React from 'react';
import Icon from '../../../../components/AppIcon';

const SecurityMessage = () => {
  return (
    <div className="mt-6 p-4 bg-accent-50 rounded-lg border border-accent-200">
      <div className="flex items-start space-x-3">
        <Icon name="Shield" size={20} className="text-accent-600 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-sm font-medium text-accent-800 mb-1">
            Security Notice
          </h3>
          <p className="text-xs text-accent-600">
            For your security, we only send password reset links to verified email addresses.
            The link will expire in 24 hours and can only be used once.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityMessage;